// 页面跳转loading
import ElementUI from 'element-ui'

var loading = null;

const loadingConfig = {
  lock:true,
  text:'',
  spinner:'el-icon-loading',
  background:'rgba(56, 58, 66, 1)',
  customClass:'fullScreenLoading'
}

const loadingShow = () => {
  loading = ElementUI.Loading.service(loadingConfig)
}

const loadingHide = () => {
  loading.close();
}

const loadingObj = {
  loadingShow,
  loadingHide,
}

export default loadingObj



// WEBPACK FOOTER //
// ./src/components/loading/index.js